import axios from 'axios'
const state = () => ({
    news: []
})

const getters = {
    news(state) {
        return state.news
    }
}

const mutations = {
    SET_NEWS(state, payload){
        state.news = payload
    },
}

const actions = {
    getNews({commit}, payload){
        axios.get(`https://api.geomalaka.uz/api/main/news/?page=${payload?.page ? payload?.page : 1}`)
            .then((res)=>{
                commit("SET_NEWS", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
     getNewsByCategory({commit}, code){
        axios.get(`https://api.geomalaka.uz/api/main/news/?page=1&category=${code}`)
            .then((res)=>{
                commit("SET_NEWS", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
    getNewsById({commit}, id){
        axios.get(`https://api.geomalaka.uz/api/main/news/${id}/`)
            .then((res)=>{
                commit("SET_NEWS", res.data)
            })
            .catch((error)=>{console.log(error)})
    },
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
